import React, { useState } from 'react';
import { Form, SecondaryButton, FieldTextInput, FieldPhoneNumberInput } from '../../components';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import css from './ContactPage.module.css';
import isEqual from 'lodash/isEqual';

const ContactForm = props => {
  const [submittedValues, setSubmittedValues] = useState({});
  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const {
          formId,
          handleSubmit,
          inProgress,
          pristine,
          intl,
          invalid,
          form,
          values,
          submitErrorMessage,
          submitSucceedMessage,
          submitSucceed,
        } = fieldRenderProps;

        const submittedOnce = Object.keys(submittedValues).length > 0;
        const pristineSinceLastSubmit = submittedOnce && isEqual(values, submittedValues);
        const submitDisabled = invalid || pristineSinceLastSubmit || inProgress;

        const firstNameLabel = intl.formatMessage({ id: 'ContactPage.firstNameLabel' });
        const firstNamePlaceholder = intl.formatMessage({ id: 'ContactPage.firstNamePlaceholder' });

        const firstNameRequiredMessage = intl.formatMessage({
          id: 'ContactPage.firstNameRequired',
        });
        const firstNameRequired = validators.required(firstNameRequiredMessage);

        const lastNameLabel = intl.formatMessage({ id: 'ContactPage.lastNameLabel' });
        const lastNamePlaceholder = intl.formatMessage({ id: 'ContactPage.lastNamePlaceholder' });

        const lastNameRequiredMessage = intl.formatMessage({
          id: 'ContactPage.lastNameRequired',
        });

        const lastNameRequired = validators.required(lastNameRequiredMessage);

        const emailLabel = intl.formatMessage({ id: 'ContactPage.emailLabel' });
        const emailPlaceholder = intl.formatMessage({ id: 'ContactPage.emailPlaceholder' });

        const emailRequiredMessage = intl.formatMessage({
          id: 'ContactPage.emailRequired',
        });
        const emailValidMessage = intl.formatMessage({
          id: 'ContactPage.emailValid',
        });
        const emailRequired = validators.required(emailRequiredMessage);
        const emailValid = validators.emailFormatValid(emailValidMessage);

        const phoneLabel = intl.formatMessage({ id: 'ContactPage.phoneLabel' });
        const phonePlaceholder = intl.formatMessage({ id: 'ContactPage.phonePlaceholder' });

        const messageLabel = intl.formatMessage({ id: 'ContactPage.messageLabel' });
        const messagePlaceholder = intl.formatMessage({ id: 'ContactPage.messagePlaceholder' });

        const messageRequiredMessage = intl.formatMessage({
          id: 'ContactPage.messageRequired',
        });

        const messageRequired = validators.required(messageRequiredMessage);
        const submitForm = e => {
          handleSubmit(e).then(() => {
            setSubmittedValues(values);
            form.reset();
            Object.keys(values).forEach(key => {
              form.resetFieldState(key);
            });
          });
        };

        return (
          <Form className={css.contactForm} onSubmit={submitForm}>
            <div className={css.fields}>
              <FieldTextInput
                id={formId ? `${formId}_firstName` : 'firstName'}
                name="firstName"
                type="text"
                label={firstNameLabel}
                placeholder={firstNamePlaceholder}
                validate={firstNameRequired}
                className={css.input}
              />
              <FieldTextInput
                id={formId ? `${formId}_lastName` : 'lastName'}
                name="lastName"
                type="text"
                label={lastNameLabel}
                placeholder={lastNamePlaceholder}
                validate={lastNameRequired}
                className={css.input}
              />
            </div>
            <div className={css.fields}>
              <FieldTextInput
                id={formId ? `${formId}_email` : 'email'}
                name="email"
                type="text"
                label={emailLabel}
                placeholder={emailPlaceholder}
                validate={validators.composeValidators(emailRequired, emailValid)}
                className={css.input}
              />
              <FieldPhoneNumberInput
                id={formId ? `${formId}_phone` : 'phone'}
                name="phone"
                label={phoneLabel}
                placeholder={phonePlaceholder}
                className={css.input}
              />
            </div>
            <FieldTextInput
              id={formId ? `${formId}_message` : 'message'}
              name="message"
              type="texarea"
              label={messageLabel}
              placeholder={messagePlaceholder}
              validate={messageRequired}
              className={css.input}
            />
            <div>
              <SecondaryButton
                disabled={submitDisabled}
                className={css.sendBtn}
                inProgress={inProgress}
                ready={pristineSinceLastSubmit}
              >
                <FormattedMessage id="ContactPage.send" />
              </SecondaryButton>
            </div>
            {submitErrorMessage}
            {submitSucceedMessage}
          </Form>
        );
      }}
    />
  );
};
ContactForm.displayName = 'ContactForm';

export default ContactForm;
